module.exports = __webpack_public_path__ + "components/flag/static/square/to-6a748e31483c1d6f2f0d1ecb77d540ef.svg";